"use strict";

var _classCallCheck = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/assertThisInitialized");

var _inherits = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

module.exports = function (core) {
  var XMLHttpRequestEventTarget = core.XMLHttpRequestEventTarget;

  var XMLHttpRequestUpload = /*#__PURE__*/function (_XMLHttpRequestEventT) {
    _inherits(XMLHttpRequestUpload, _XMLHttpRequestEventT);

    function XMLHttpRequestUpload() {
      var _this;

      _classCallCheck(this, XMLHttpRequestUpload);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(XMLHttpRequestUpload).call(this));

      if (!(_assertThisInitialized(_this) instanceof XMLHttpRequestUpload)) {
        throw new TypeError("DOM object constructor cannot be called as a function.");
      }

      return _this;
    }

    return XMLHttpRequestUpload;
  }(XMLHttpRequestEventTarget);

  core.XMLHttpRequestUpload = XMLHttpRequestUpload;
};